import type React from "react"
import { Box, Container, Typography, Grid, Link, Divider, useTheme } from "@mui/material"
import RestaurantIcon from "@mui/icons-material/Restaurant"
import CleaningServicesIcon from "@mui/icons-material/CleaningServices"

const Footer: React.FC = () => {
    const theme = useTheme();
  return (
    <Box component="footer" sx={{ py: 6, borderTop: 1, borderColor: "divider" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <img
                    src={require("../../assets/logo.png")}
                    alt="Google Play"
                    style={{ width: "50px", height: "50px", backgroundColor: theme.palette.primary.main }}
                />
              <Typography variant="h6" component="div" sx={{ fontWeight: "bold", ml: 2 }}>
                Cooks and Maids
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              Connecting households with verified cooks and maids across India.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {["How It Works", "Why Choose Us", "Testimonials", "Contact"].map((item) => (
                <Link
                  key={item}
                  href={`#${item.toLowerCase().replace(/\s+/g, "-")}`}
                  underline="hover"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  {item}
                </Link>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Email: support@cooksandmaids.in
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Phone: +91 7995740545
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "center", sm: "flex-start" },
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Cooks and Maids. All rights reserved.
          </Typography>
          <Box sx={{ display: "flex", gap: 3, mt: { xs: 2, sm: 0 } }}>
            <Link href="#" underline="hover" color="text.secondary" variant="body2">
              Privacy Policy
            </Link>
            <Link href="#" underline="hover" color="text.secondary" variant="body2">
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
